import React from "react";
import Header from "../Home/Header";
import Footer from "../Home/Footer";
import MarketingServiceDetail from "./MarketingServiceDetail";
import { useParams } from "react-router-dom";
import { marketingData } from "./marketingData";

function MarketingDetailPage() {
  const { id } = useParams();
  const service = marketingData.find((s) => s.id === parseInt(id));

  if (!service) {
    return (
      <div>
        <Header />
        <div style={{ padding: "100px 0", textAlign: "center", fontFamily: "'Sora', sans-serif" }}>
          <i className="fas fa-exclamation-triangle" style={{ fontSize: "48px", color: "#cbd5e1", marginBottom: "20px", display: "block" }} />
          <h1 style={{ color: "#000662", fontWeight: 800 }}>Service not found</h1>
          <p style={{ color: "#60616c", marginTop: "8px" }}>The marketing service you're looking for doesn't exist.</p>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div>
      <Header />
      <MarketingServiceDetail service={service} />
      <Footer />
    </div>
  );
}

export default MarketingDetailPage;
